module.exports = __webpack_public_path__ + "img/modelo-cs2.6fa67396.png";